import AuthenticationLayout from 'components/AuthLayout';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import useSWR from 'swr';
import NotFound from '../not-found';
import LoginRequired from './error/login-required';
import VerifiedEmailRequired from './error/verified-email-required';
import Settings from './settings';
import EditInformationPage from './settings/EditInformation';

const UserRoutes: FC = () => {
  const { data, error } = useSWR('/auth/profile');
  return data && !error ? (
    <Routes>
      <Route path="/settings/*" element={<Settings />} />
      <Route
        path="/settings/edit-information"
        element={<EditInformationPage />}
      />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  ) : (
    <Routes>
      <Route
        path="/settings/*"
        element={
          error?.response?.status === 403 ? (
            <AuthenticationLayout src_image="/logo_institut_principal.png">
              <VerifiedEmailRequired />
            </AuthenticationLayout>
          ) : (
            <AuthenticationLayout src_image="/logo_institut_principal.png">
              <LoginRequired />
            </AuthenticationLayout>
          )
        }
      />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default UserRoutes;
